import * as React from "react"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import TextArea from "@bappweb/textarea"
import Button from "@bappweb/button"
import DatePicker from "@bappweb/datepicker"
import Select from "@bappweb/select"
import FileUpload from "@bappweb/fileupload"
import Checkbox from "@bappweb/checkbox"
import RadioGroup from "@bappweb/radiogroup"
import Radio from "@bappweb/radio"
import Slider from "@bappweb/slider"
import Icon from "@bappweb/icon"
import LargeToggle, { LargeToggleButton } from "@bappweb/largetoggle"
import {
  email as checkEmail,
  fileType,
  minValue,
  numeric,
  RegexpTypes,
  required,
  timeFormat
} from "@bappweb/utils"
import optionsMock from "./mockData.json"
import Page from "@components/globalmodules/page"

type PropsType = {
  onError?: (event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) => void
  onSubmit?: (event?: React.BaseSyntheticEvent, values?: Record<string, any>) => void
}

const startDate = new Date()
const endDate = new Date()
endDate.setMonth(startDate.getMonth() + 3)

function DemoForm({ onError, onSubmit }: PropsType) {
  function handleError(event?: React.BaseSyntheticEvent, errorField?: Record<string, any>) {
    if (onError) {
      onError(event, errorField)
    }
  }

  function handleSubmit(e?: React.BaseSyntheticEvent, values?: Record<string, any>) {
  
    if (onSubmit) {
      onSubmit(e, values)
    }
  }

  return (
    <Page>
      <Form name="formModuleWithPanel" onError={handleError} onSubmit={handleSubmit} grid={false}>
        <Panel hasFooter connected={false}>
          <Panel.Header title="Form Module in Panel" />
          <Panel.Body>
            <TextField
              label="First name2"
              placeholder="First name"
              type="text"
              name="name"
              validations={[required("Ad zorunlu alandır")]}
            />
            <TextField
              label="Last name"
              placeholder="Last name"
              type="text"
              name="surname"
              isCapsLockOn
              validations={[required("Soyad zorunlu alandır")]}
            />
            <TextField
              label="Email"
              placeholder="Email"
              type="text"
              name="email"
              validations={[
                required("E-Posta zorunlu alandır"),
                checkEmail("Lütfen geçerli formatta bir E-Posta giriniz.")
              ]}
            />
            <TextField
              label="Time"
              placeholder="Time"
              type="text"
              name="time"
              mask="11:11"
              getMaskedValue
              validations={[
                required("Time zorunlu alandır"),
                timeFormat("Lütfen geçerli formatta bir saat giriniz.")
              ]}
            />
            <TextField
              label="Numeric"
              placeholder="Numeric"
              type="number"
              name="numeric"
              validator={RegexpTypes.Numeric}
              validations={[required("Numeric zorunlu bir alandır"), numeric(), minValue(1000)]}
            />
            <TextArea
              label="Adres"
              maxRows={5}
              name="adress"
              placeholder="Adres"
              validations={[required("Lütfen adresinizi giriniz!")]}
            />
            <Select
              label="Currency"
              name="currency"
              options={optionsMock.options}
              placeholder="Currency"
              displayField="CurrencyNameTR"
              valueField="CurrencyCodeNumerical"
              validations={[required("Lütfen bir döviz seçiniz")]}
            />
            <DatePicker
              label="Date"
              name="date"
              validations={[required("Tarih alanı zorunludur.")]}
              showYearDropdown
              showMonthDropdown
              dateFormat="dd.MM.yyyy"
              maxDate={endDate}
              minDate={startDate}
              selected={startDate}
              value={startDate}
            />
            <DatePicker
              label="Date 2"
              name="date2"
              validations={[required("Tarih alanı zorunludur.")]}
              dateFormat="dd.MM.yyyy"
            />
            <FileUpload
              label="Upload documents"
              name="upload"
              browseText="Browse"
              multiple
              accept=".txt"
              fileTypes="text/plain"
              validations={[
                required("Lütfen bir dosya seçiniz"),
                fileType("Lütfen txt uzantılı dosya yükleyiniz")
              ]}
            />
            <Slider
              label="Vade Sayısı"
              name="term"
              min={0}
              max={100}
              step={1}
              valueTitle="Ay"
              validations={[minValue(10, "Vade sayısı en az 10 olabilir")]}
            />
            <LargeToggle
              label="Choose one"
              toggleText="Paypass is a fast, easy and secure way to pay by card for purchases costing 50,00 TL and under, without ever having to enter a PIN. This technology is becoming increasingly common in Europe."
              disabled={false}
              name="toggle"
              validations={[required("Zorunlu")]}>
              <LargeToggleButton
                text="Always"
                name="button1"
                value="1"
                iconName={Icon.Icons.AccountsCardsAccounts}
              />
              <LargeToggleButton
                text="Sometimes"
                name="button2"
                value="2"
                iconName={Icon.Icons.ActionsControlsAddStyle}
              />
              <LargeToggleButton
                text="Never"
                name="button3"
                value="3"
                iconName={Icon.Icons.ActionsControlsSettings}
              />
            </LargeToggle>
            <RadioGroup
              label="Framework'ün kullanılacağı proje"
              name="projectType"
              value="1"
              block={false}
              validations={[required("Bu framework'ün kullanılması zorunludur")]}>
              <Radio label="ATM Yenileme" name="projecttyperadio" value="1" />
              <Radio label="İnternet Şube Yenileme" name="projecttyperadio" value="2" />
              <Radio label="Çağrı Merkezi Yenileme" name="projecttyperadio" value="3" />
            </RadioGroup>
            <RadioGroup
              label="Block Radios"
              name="transferType"
              // value="radio1"
              block
              validations={[required("Bu alan zorunludur")]}>
              <Radio label="IBAN ile gönder" name="transfertyperadio" value="radio1" />
              <Radio label="Hesaba gönder" name="transfertyperadio" value="radio2" />
              <Radio label="Cebe gönder" name="transfertyperadio" value="radio3" />
              <Radio label="ATM'e gönder" name="transfertyperadio" value="radio4" />
            </RadioGroup>
            <Checkbox
              label="Bu formu çok beğendiğimi beyan eder, her ekibin bu framework'ü kullanmasını tereddütsüz tavsiye ederim"
              name="checkboxSingle"
              validations={[required("Bu framework'ün kullanılmasını tavsiye etmek zorunludur")]}
            />
          </Panel.Body>
          <Panel.Footer>
            <Panel.RightFooter>
              <Button text="KAYDET" type="submit" />
            </Panel.RightFooter>
          </Panel.Footer>
        </Panel>
      </Form>
    </Page>
  )
}

export default DemoForm
